import { render } from "./team-absences-user-row.vue?vue&type=template&id=05a26710&ts=true"
import script from "./team-absences-user-row.vue?vue&type=script&lang=ts"
export * from "./team-absences-user-row.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__